import { render, staticRenderFns } from "./PFLoanFormFrontNew.vue?vue&type=template&id=5dc8a942"
import script from "./PFLoanFormFrontNew.vue?vue&type=script&lang=js"
export * from "./PFLoanFormFrontNew.vue?vue&type=script&lang=js"
import style0 from "./PFLoanFormFrontNew.vue?vue&type=style&index=0&id=5dc8a942&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports